// EN/TR translations for The Real Turkish Barber (single Bray location)

export const translations = {
  en: {
    seo: {
      title: 'Turkish Barber Bray | The Real Turkish Barber — Skin Fades, Beards & Hot Towel Shaves',
      description:
        "The Real Turkish Barber in Bray, Co. Wicklow. Authentic Turkish barbering — men's haircuts, skin fades, beard trims & traditional hot towel shaves. ★5.0 on Google. Walk-ins welcome. Book now."
    },
    nav: {
      home: 'Home',
      services: 'Services',
      prices: 'Prices',
      gallery: 'Gallery',
      reviews: 'Reviews',
      findUs: 'Find Us',
      bookNow: 'Book Now'
    },
    whatsappMsg: "Hi, I'd like to book a haircut at The Real Turkish Barber in Bray.",
    hero: {
      badge: '★★★★★ 5.0 Google Rating',
      subtitle: 'Authentic Turkish Barbering in Bray',
      desc: 'Professional cuts, skin fades, beard grooming and traditional hot towel shaves — delivered with authentic Turkish barbering.',
      book: 'Book Now',
      call: 'Call Now'
    },
    trust: {
      rating: '5.0 Google Rating',
      authentic: 'Authentic Turkish Barbering',
      pros: 'Professional Barbers',
      walkins: 'Walk-ins Welcome',
      local: "Bray's Turkish Barber"
    },
    servicesSection: { label: 'What We Do', title: 'Our Services', viewAll: 'View All Services' },
    services: {
      haircut: { name: 'Haircut', desc: "Classic and modern men's cuts finished with professional styling." },
      skinFade: { name: 'Skin Fade', desc: 'Precision fading with clean lines and a sharp finish.' },
      beard: { name: 'Beard Trim & Shape', desc: 'Professional beard shaping tailored to your face.' },
      hotTowel: { name: 'Hot Towel Shave', desc: 'Traditional Turkish hot towel shaving experience.' },
      kids: { name: 'Kids Haircut', desc: 'Gentle, friendly cuts for our younger clients.' },
      vip: { name: 'VIP Grooming Experience', desc: 'The complete premium grooming experience.' }
    },
    pricesSection: { label: 'Transparent Pricing', title: 'Price List', book: 'Book Now', zoom: 'Click to enlarge' },
    promo: {
      badge: 'Student Special',
      days: 'Monday to Thursday',
      title: 'Dry Haircut',
      price: '€15',
      book: 'Book Now'
    },
    gallerySection: { label: 'Our Work', title: 'Gallery' },
    reviewsSection: {
      label: '5.0 ★★★★★ on Google',
      title: 'What Our Clients Say',
      readGoogle: 'Read Our Google Reviews',
      leaveReview: 'Leave a Review'
    },
    about: {
      label: 'About Us',
      title: 'Authentic Turkish Barbering in Bray',
      body: 'Experience authentic Turkish barbering in the heart of Bray. From precision haircuts and skin fades to traditional beard grooming and hot towel shaves, The Real Turkish Barber combines traditional techniques with modern styling.'
    },
    findUs: {
      label: 'Visit Us',
      title: 'Find Us in Bray',
      shopName: 'The Real Turkish Barber — Bray',
      hoursTitle: 'Opening Hours',
      weekday: 'Monday – Saturday: 9:30 AM – 7:00 PM',
      sunday: 'Sunday: 11:00 AM – 4:00 PM',
      directions: 'Get Directions',
      call: 'Call Now',
      whatsapp: 'WhatsApp',
      book: 'Book Now'
    },
    cta: {
      ready: 'Ready for a fresh cut?',
      readyDesc: 'Book your next haircut with The Real Turkish Barber in Bray.',
      book: 'Book Your Appointment'
    },
    footer: {
      tagline: 'Authentic Turkish Barbering in Bray',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      hours: 'Opening Hours',
      language: 'Language',
      rights: 'All rights reserved.'
    }
  },
  tr: {
    seo: {
      title: 'Bray Türk Berberi | The Real Turkish Barber — Saç Kesimi, Skin Fade ve Sıcak Havlu Tıraşı',
      description:
        "Bray, Co. Wicklow'da gerçek Türk berberliği. Erkek saç kesimi, skin fade, sakal tıraşı ve geleneksel sıcak havlu tıraşı. Google'da ★5.0. Yürüyerek gelebilirsiniz. Hemen randevu alın."
    },
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      prices: 'Fiyatlar',
      gallery: 'Galeri',
      reviews: 'Yorumlar',
      findUs: 'Bize Ulaşın',
      bookNow: 'Randevu Al'
    },
    whatsappMsg: "Merhaba, The Real Turkish Barber Bray'de saç kesimi için randevu almak istiyorum.",
    hero: {
      badge: '★★★★★ 5.0 Google Puanı',
      subtitle: "Bray'de Gerçek Türk Berberliği",
      desc: 'Profesyonel saç kesimi, skin fade, sakal bakımı ve geleneksel sıcak havlu tıraşı — gerçek Türk berberliğiyle.',
      book: 'Randevu Al',
      call: 'Hemen Ara'
    },
    trust: {
      rating: '5.0 Google Puanı',
      authentic: 'Gerçek Türk Berberliği',
      pros: 'Profesyonel Berberler',
      walkins: 'Randevusuz Gelebilirsiniz',
      local: "Bray'in Türk Berberi"
    },
    servicesSection: { label: 'Ne Yapıyoruz', title: 'Hizmetlerimiz', viewAll: 'Tüm Hizmetler' },
    services: {
      haircut: { name: 'Saç Kesimi', desc: 'Profesyonel şekillendirmeyle klasik ve modern erkek kesimleri.' },
      skinFade: { name: 'Skin Fade', desc: 'Keskin ve temiz geçişlerle hassas fade.' },
      beard: { name: 'Sakal Tıraşı & Şekillendirme', desc: 'Yüzünüze özel profesyonel sakal şekillendirme.' },
      hotTowel: { name: 'Sıcak Havlu Tıraşı', desc: 'Geleneksel Türk sıcak havlu tıraş deneyimi.' },
      kids: { name: 'Çocuk Saç Kesimi', desc: 'Küçük müşterilerimiz için nazik ve keyifli kesimler.' },
      vip: { name: 'VIP Bakım Deneyimi', desc: 'Eksiksiz premium bakım deneyimi.' }
    },
    pricesSection: { label: 'Şeffaf Fiyatlandırma', title: 'Fiyat Listesi', book: 'Randevu Al', zoom: 'Büyütmek için tıklayın' },
    promo: {
      badge: 'Öğrenci Fırsatı',
      days: 'Pazartesi – Perşembe',
      title: 'Kuru Saç Kesimi',
      price: '€15',
      book: 'Randevu Al'
    },
    gallerySection: { label: 'Çalışmalarımız', title: 'Galeri' },
    reviewsSection: {
      label: "Google'da 5.0 ★★★★★",
      title: 'Müşterilerimiz Ne Diyor',
      readGoogle: 'Google Yorumlarını Oku',
      leaveReview: 'Yorum Bırak'
    },
    about: {
      label: 'Hakkımızda',
      title: "Bray'de Gerçek Türk Berberliği",
      body: "Bray'in kalbinde gerçek Türk berberliği deneyimini yaşayın. Profesyonel saç kesimleri, skin fade, sakal şekillendirme ve geleneksel sıcak havlu tıraşından modern saç stillerine kadar, The Real Turkish Barber geleneksel Türk berberlik tekniklerini modern tarzlarla birleştirir."
    },
    findUs: {
      label: 'Ziyaret Edin',
      title: "Bray'de Bizi Bulun",
      shopName: 'The Real Turkish Barber — Bray',
      hoursTitle: 'Çalışma Saatleri',
      weekday: 'Pazartesi – Cumartesi: 09:30 – 19:00',
      sunday: 'Pazar: 11:00 – 16:00',
      directions: 'Yol Tarifi',
      call: 'Hemen Ara',
      whatsapp: 'WhatsApp',
      book: 'Randevu Al'
    },
    cta: {
      ready: 'Yeni bir kesime hazır mısınız?',
      readyDesc: "Bray'deki The Real Turkish Barber ile bir sonraki randevunuzu alın.",
      book: 'Randevu Alın'
    },
    footer: {
      tagline: "Bray'de Gerçek Türk Berberliği",
      quickLinks: 'Hızlı Bağlantılar',
      contact: 'İletişim',
      hours: 'Çalışma Saatleri',
      language: 'Dil',
      rights: 'Tüm hakları saklıdır.'
    }
  }
};
